'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

require('../../styles/sections/index-cta.scss');

exports.default = (0, _themeSections.register)('index-cta', {
  onLoad: function onLoad() {},
  onUnload: function onUnload() {}
});